const h = {
  name: "Singapore",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M6,0h6v4h3V2h2v2h3V2h2v2h3V2h2v2h3V0h6v4h4v6h-3v2h1v26h2v2H2v-2h2V12h1v-2c-2.8,0-5-2.2-5-5V4h6V0z M36,14
			h-6v24h6V14z M28,12h1v-2h-4v2h1v26h2V12z M24,14h-6v24h6V14z M16,12h1v-2h-4v2h1v26h2V12z M12,14H6v24h6V14z M38,8V6H2.2
			C2.6,7.2,3.7,8,5,8H38z M31,10v2h4v-2H31z M34,4V2h-2v2H34z M7,12h4v-2H7V12z M19,12h4v-2h-4V12z M10,2H8v2h2V2z"/>
	</g>
</g>
</svg>
  `
};
export {
  h as Singapore
};
